// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
  color: #32879c;
  border-color: #32879c;
}
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  background-color: #32879c;
  color: #fff;
}
.bg-white {
  background-color: #fff;
}
.mainDiv {
  margin-top: 80px;
}

.boxDIC {
  background: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  padding: 10px;
  color: #353535;
  min-height: 200px;
}
h5,
.h5 {
  font-size: 1.1rem !important;
}
p {
  line-height: 1rem !important;
}
small,
.small {
  font-size: 80% !important;
}

table tr td {
  font-size: 0.8em;
}
.accordion-button {
  font-size: 0.5em;
}
.accordion-button:not(.collapsed) {
  background-color: #e0e0e0;
  color: #222;
}

/* media queries start here */
@media screen and (max-width: 740px) {
  .titlebg {
    font-size: 0.9em;
  }
}
@media (max-width: 768px) {
  .popover,
  .dropdown-menu {
    top: 20% !important;
  }
}

@media only screen and (max-width: 380px) {
  .mainDiv {
    margin-top: 170px;
  }
}

@media only screen and (max-width: 768px) {
  .mainDiv {
    margin-top: 130px;
  }
}

@media screen and (max-width: 480px) {
  .titlebg {
    font-size: 0.9em;
  }
}

.vehicle_details_data {
  background: transparent;
  padding: 0px !important;
  margin-bottom: 0px !important;
  color: #358696 !important;
  font-weight: 600;
  display: block;
}
.react-datepicker__input-container input[type="text"] {
  width: 100%;
  background: #fff;
  height: 35px;
  border: solid 1px #a5a5a5;
  border-radius: 3px;
  font-size: 14px;
  color: #353535;
  text-indent: 10px;
  margin-bottom: 12px;
}
.top-filter {
  width: 100%;
  background: #fff;
  height: 35px;
  border: solid 1px #a5a5a5;
  border-radius: 3px;
  font-size: 14px;
  color: #353535;
  text-indent: 10px;
  margin-bottom: 12px;
}
.css-1r4vtzz {
  border-radius: 3px !important;
  font-size: 14px !important;
  color: #353535 !important;
  padding: 5px 5px !important;
  text-indent: 10px !important;
}
.css-1r4vtzz {
  width: 100% !important;
}
.submit_btn {
  color: #fff !important;
  width: 100%;
  margin-top: 23%;
  background: #32879c;
  border: #32879c;
}

.reset_btn {
  color: #fff !important;
  width: 100%;
  margin-top: 23%;
  background: #7b7878;
  border: silver;
}

@media screen and (max-width: 768px) {
  .submit_btn {
    margin-top: 2%;
  }

  .reset_btn {
    margin-top: 2%;
  }
}

.FilterDivDIC {
  background: #e7e7e7;
  /* padding-top: 25px; */
  /* padding-bottom: 10px; */
  /* margin-right: -5px; */
  /* margin-left: -1px; */
  /* margin-top: 2px; */
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */
}

/***************************/
strong.align-top-chn {
  top: 35px;
}
strong#oldpz {
  top: 28px;
  right: 4px;
  z-index: 1;
}

.row.equal-cols {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-cols:before,
.row.equal-cols:after {
  display: block;
}

.row.equal-cols > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.row.equal-cols > [class*="col-"] > * {
  flex: 1 1 auto;
}

.new_drive_dashboardDIC {
  background-color: #ecf1f4;
}

.drivediv {
  /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;
}

.drive_selection_box {
  border: 1px solid #e9eef4;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;
}

.indicator_lamp {
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
  padding: 0px 3rem 5px 3rem;
  background-color: white;
  border: 1px solid #dcdbdb;
}

.borderDownDIC {
  border-radius: 6px;
}

.boxTitleDIC {
  /* background-color: #cdcfce; */
  background-color: #32879c;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  color: white !important;
  font-size: 1.1em !important;
  font-weight: 600 !important;
}

.raphael-group-GUjlfOCU {
  display: none !important;
}

.table {
  width: 100%; /* Ensure the table takes up the full width */
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/RangePolygon/DigitalInstrumentalCluster.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;EASE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA,4BAA4B;AAC5B;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EAGE,aAAa;EAGb,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,sBAAsB;AACxB;;AAEA;EAGE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;EACjE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW,EAAE,6CAA6C;AAC5D","sourcesContent":[".btn-outline-primary {\n  color: #32879c;\n  border-color: #32879c;\n}\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  background-color: #32879c;\n  color: #fff;\n}\n.bg-white {\n  background-color: #fff;\n}\n.mainDiv {\n  margin-top: 80px;\n}\n\n.boxDIC {\n  background: #ffffff;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  padding: 10px;\n  color: #353535;\n  min-height: 200px;\n}\nh5,\n.h5 {\n  font-size: 1.1rem !important;\n}\np {\n  line-height: 1rem !important;\n}\nsmall,\n.small {\n  font-size: 80% !important;\n}\n\ntable tr td {\n  font-size: 0.8em;\n}\n.accordion-button {\n  font-size: 0.5em;\n}\n.accordion-button:not(.collapsed) {\n  background-color: #e0e0e0;\n  color: #222;\n}\n\n/* media queries start here */\n@media screen and (max-width: 740px) {\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n@media (max-width: 768px) {\n  .popover,\n  .dropdown-menu {\n    top: 20% !important;\n  }\n}\n\n@media only screen and (max-width: 380px) {\n  .mainDiv {\n    margin-top: 170px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .mainDiv {\n    margin-top: 130px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n\n.vehicle_details_data {\n  background: transparent;\n  padding: 0px !important;\n  margin-bottom: 0px !important;\n  color: #358696 !important;\n  font-weight: 600;\n  display: block;\n}\n.react-datepicker__input-container input[type=\"text\"] {\n  width: 100%;\n  background: #fff;\n  height: 35px;\n  border: solid 1px #a5a5a5;\n  border-radius: 3px;\n  font-size: 14px;\n  color: #353535;\n  text-indent: 10px;\n  margin-bottom: 12px;\n}\n.top-filter {\n  width: 100%;\n  background: #fff;\n  height: 35px;\n  border: solid 1px #a5a5a5;\n  border-radius: 3px;\n  font-size: 14px;\n  color: #353535;\n  text-indent: 10px;\n  margin-bottom: 12px;\n}\n.css-1r4vtzz {\n  border-radius: 3px !important;\n  font-size: 14px !important;\n  color: #353535 !important;\n  padding: 5px 5px !important;\n  text-indent: 10px !important;\n}\n.css-1r4vtzz {\n  width: 100% !important;\n}\n.submit_btn {\n  color: #fff !important;\n  width: 100%;\n  margin-top: 23%;\n  background: #32879c;\n  border: #32879c;\n}\n\n.reset_btn {\n  color: #fff !important;\n  width: 100%;\n  margin-top: 23%;\n  background: #7b7878;\n  border: silver;\n}\n\n@media screen and (max-width: 768px) {\n  .submit_btn {\n    margin-top: 2%;\n  }\n\n  .reset_btn {\n    margin-top: 2%;\n  }\n}\n\n.FilterDivDIC {\n  background: #e7e7e7;\n  /* padding-top: 25px; */\n  /* padding-bottom: 10px; */\n  /* margin-right: -5px; */\n  /* margin-left: -1px; */\n  /* margin-top: 2px; */\n  position: relative;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */\n}\n\n/***************************/\nstrong.align-top-chn {\n  top: 35px;\n}\nstrong#oldpz {\n  top: 28px;\n  right: 4px;\n  z-index: 1;\n}\n\n.row.equal-cols {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.row.equal-cols:before,\n.row.equal-cols:after {\n  display: block;\n}\n\n.row.equal-cols > [class*=\"col-\"] {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.row.equal-cols > [class*=\"col-\"] > * {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n\n.new_drive_dashboardDIC {\n  background-color: #ecf1f4;\n}\n\n.drivediv {\n  /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;\n}\n\n.drive_selection_box {\n  border: 1px solid #e9eef4;\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;\n}\n\n.indicator_lamp {\n  width: 100%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 0 0 4px 4px;\n  padding: 0px 3rem 5px 3rem;\n  background-color: white;\n  border: 1px solid #dcdbdb;\n}\n\n.borderDownDIC {\n  border-radius: 6px;\n}\n\n.boxTitleDIC {\n  /* background-color: #cdcfce; */\n  background-color: #32879c;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  color: white !important;\n  font-size: 1.1em !important;\n  font-weight: 600 !important;\n}\n\n.raphael-group-GUjlfOCU {\n  display: none !important;\n}\n\n.table {\n  width: 100%; /* Ensure the table takes up the full width */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
